// extracted by mini-css-extract-plugin
export default {"dialog":"TwoOptionsDialog_dialog__0zHIV","actionsRow":"TwoOptionsDialog_actionsRow__OquZN","formButton":"TwoOptionsDialog_formButton__NV7gD"};